import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WorkspaceAgentActionsMenuGroupId } from './useTrackAgentActionsMenuGroupOpened.meta';
import META from './useTrackAgentActionsMenuTaskSelected.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentActionsMenuTaskSelectedParams = {
  task_id: string;
  group_id: WorkspaceAgentActionsMenuGroupId;
  via_search: boolean;
};

export const useTrackAgentActionsMenuTaskSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentActionsMenuTaskSelected = useCallback(
    (params: UseTrackAgentActionsMenuTaskSelectedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentActionsMenuTaskSelected };
};
